import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import ChatPage from "@/pages/ChatPage";
import StoriesPage from "@/pages/StoriesPage";
import StoryPage from "@/pages/StoryPage";
import LullabiesPage from "@/pages/LullabiesPage";
import LullabyPage from "@/pages/LullabyPage";
import { trackVisit } from "@/lib/track";

function App() {
  useEffect(() => {
    trackVisit();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/stories" element={<StoriesPage />} />
          <Route path="/stories/:sourceKey" element={<StoryPage />} />
          <Route path="/stories/:sourceKey/:slug" element={<StoryPage />} />
          <Route path="/lullabies" element={<LullabiesPage />} />
          <Route path="/lullabies/:sourceKey" element={<LullabyPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
